angular.module("Main").controller("AutoLoginController", ["$state", "$stateParams", "AuthenticationService", "SessionService",
    function ($state, $stateParams, AuthenticationService, SessionService) {
        var vm = this;

        //$state.go("welcome", {cid: $stateParams.cid})

        let email = $stateParams.email;
        let password = $stateParams.pwd;
        let clubId = $stateParams.cid;
        if (_.isUndefined($stateParams.id)) {
            var uuid = false;
        } else if ($stateParams.id) {
            var uuid = $stateParams.id;
        }

        if (!_.isEmpty(clubId)) {
            SessionService.setAuthData(clubId, uuid, true);

            AuthenticationService.login(email, password).then(function (response) {
                if (response != null) {
                    // if (!SessionService.getSessionId())
                    //    SessionService.setAuthData(clubId);
                    $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                } else {
                    $state.go("no_access");
                }
            }).catch(function () {
                $state.go("no_access");
            });
        } else
            $state.go("no_access");
    }]);